import _defineProperty from './node_modules/@babel/runtime/helpers/defineProperty.js';

var _SELF_REPORTED_CREDIT, _SELF_REPORTED_CREDIT2;
var SELF_REPORTED_CREDIT_LOOKUP = {
  EXCELLENT: 'R_720_850',
  GOOD: 'R_660_719',
  AVERAGE: 'R_620_659',
  POOR: 'R_580_619',
  BAD: 'R_300_579'
};
var SELF_REPORTED_CREDIT = (_SELF_REPORTED_CREDIT = {}, _defineProperty(_SELF_REPORTED_CREDIT, SELF_REPORTED_CREDIT_LOOKUP.EXCELLENT, '720 & above'), _defineProperty(_SELF_REPORTED_CREDIT, SELF_REPORTED_CREDIT_LOOKUP.GOOD, '660 - 719'), _defineProperty(_SELF_REPORTED_CREDIT, SELF_REPORTED_CREDIT_LOOKUP.AVERAGE, '620 - 659'), _defineProperty(_SELF_REPORTED_CREDIT, SELF_REPORTED_CREDIT_LOOKUP.POOR, '580 - 619'), _defineProperty(_SELF_REPORTED_CREDIT, SELF_REPORTED_CREDIT_LOOKUP.BAD, '579 or below'), _SELF_REPORTED_CREDIT);
var SELF_REPORTED_CREDIT_OPTIONS_VALUES = (_SELF_REPORTED_CREDIT2 = {}, _defineProperty(_SELF_REPORTED_CREDIT2, SELF_REPORTED_CREDIT_LOOKUP.EXCELLENT, {
  creditScoreLow: 720,
  creditScoreHigh: 850
}), _defineProperty(_SELF_REPORTED_CREDIT2, SELF_REPORTED_CREDIT_LOOKUP.GOOD, {
  creditScoreLow: 660,
  creditScoreHigh: 719
}), _defineProperty(_SELF_REPORTED_CREDIT2, SELF_REPORTED_CREDIT_LOOKUP.AVERAGE, {
  creditScoreLow: 620,
  creditScoreHigh: 659
}), _defineProperty(_SELF_REPORTED_CREDIT2, SELF_REPORTED_CREDIT_LOOKUP.POOR, {
  creditScoreLow: 580,
  creditScoreHigh: 619
}), _defineProperty(_SELF_REPORTED_CREDIT2, SELF_REPORTED_CREDIT_LOOKUP.BAD, {
  creditScoreLow: 300,
  creditScoreHigh: 579
}), _SELF_REPORTED_CREDIT2);

export { SELF_REPORTED_CREDIT, SELF_REPORTED_CREDIT_LOOKUP, SELF_REPORTED_CREDIT_OPTIONS_VALUES };
//# sourceMappingURL=constants.js.map
